<template>
	<ui-modal 
		:name="event"
		:load-success="loader.modalLoadSuccess" 
		:load="loader.modalLoad"
		title="Excluir usuário" 
		icon="fal fa-trash-alt" 
		size="xs"
	>
		<div class="modal-content-line">
			<p>
				Selecione um <span class="color-primary">{{labelComputed}}</span> para receber os dados do usuário(a)
				<span class="color-primary">{{user.first_name}}</span>.
			</p>
			<p>
				O usuário selecionado passará a fazer parte das listas de distribuição de leads e oferta ativa, caso o
				usuário(a) <strong>{{user.first_name}}</strong> faça parte de alguma dessas filas.
			</p>
		</div>

		<form class="modal-content-line form">
			<ui-team-selector
				v-model="form.team"
				name="team-selector-remove-user-modal"
				withInitValue
			/>

			<ui-select-2
				v-if="user.group_name === 'supervisor'"
				v-model="form.supervisor"
				:loading="loader.supervisorLoader"
				:data="supervisors"
				:multiple="false"
				item-label="label"
				label="Supervisor"
				size="md"
			/>

			<ui-select-2
				v-if="user.group_name === 'manager' || user.group_name === 'broker'"
				v-model="form.manager"
				:loading="loader.managerLoader"
				:data="managers"
				:multiple="false"
				item-label="label"
				label="Gerente"
				size="md"
			/>

			<ui-select-2
				v-if="user.group_name === 'broker'"
				v-model="form.broker"
				:loading="loader.brokerLoader"
				:data="brokers"
				:multiple="false"
				item-label="label"
				label="Corretor"
				size="md"
			/>
		</form>

		<div class="modal-content-line alert">
			<strong>Atenção</strong>
			<div>Ao confirmar a exclusão do usuário esta ação não poderá ser desfeita.</div>
		</div>

		<template #footer>
			<ui-button design="md link" @click="close">Cancelar</ui-button>
			<ui-button design="md danger" @click="confirm" :disabled="layout.isDisableSubmit">
				Confirmar Exclusão
			</ui-button>
		</template>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiTeamSelector } from '@/components/ui-facilita/selectors'

	import { user, team } from '@/services/axios'
	import { storage } from "@/services/storage"

	const defaultLayout = () => {
		return {
			isDisableSubmit: true,
		}
	}

	const defaultForm = () => ({
		team: null,
		supervisor: null,
		manager: null,
		broker: null
	})

	const defaultLoader = () => {
		return {
			modalLoad: false,
			modalLoadSuccess: false,
			supervisorLoader: false,
			managerLoader: false,
			brokerLoader: false
		}
	}

	export default {
		components: {
			uiModal,
			uiSelect2,
			uiButton,
			uiTeamSelector,
		},

		props: {
			event: {
				required: true,
				type: String,
			},

			autoManager: {
				required: false,
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				form: { ...defaultForm() },

				names: {
					supervisor: storage.get('label_supervisor'),
					manager: storage.get('label_manager'),
					broker: storage.get('label_broker'),
				},

				teams: [],
				supervisors: [],
				managers: [],
				brokers: [],
				showDinamycsmana: false,

				user: {},

				layout: {
					isDisableSubmit: true,
				},

				loader: {...defaultLoader},
			}
		},

		mounted() {
			/**
			 * Ao abrir o modal recebe os dados do usuário a ser bloqueado
			 */
			this.$root.$on('modal-open-' + this.event, async (data) => {
				this.resetForm()

				this.user = data.data
				this.eventSuccess = data.event

				this.$root.$emit('team-selector-' + 'team-selector-remove-user-modal', this.user)

				this.resetLayout()
				this.resetLoader()

				this.teams       = []
				this.supervisors = []
				this.managers    = []
				this.brokers     = []

				try {
					const response = await user.get(this.user.id, "team")
					this.user.manager_id = response.data.manager_id
				} catch {
					this.user.manager_id = undefined
				}
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-' + this.event)
		},

		computed: {
			labelComputed(){
				return this.names[this.user.group_name]
			},

			newUserComputed(){
				let newUser

				switch (this.user.group_name) {
					case 'broker':
						newUser = this.form.broker.id
						break;
					case 'manager':
						newUser = this.form.manager.id
						break;
					case 'supervisor':
						newUser = this.form.supervisor.id
						break;
				}

				return newUser
			}
		},

		methods: {
			/**
			 * Reseta o layout
			 */
			resetLayout() {
				this.layout = {
					...defaultLayout(),
				}
			},

			/**
			 * Reseta os loadings
			 */
			resetLoader() {
				this.loader = {
					...defaultLoader(),
				}
			},

			resetForm() {
				this.form = {
					...defaultForm(),
				}
			},

			close() {
				this.$root.$emit('modal-close-' +this.event)
			},

			/**
			 * Executado quando se confirma a exclusão do usuário
			 */
			confirm() {
				let formData = {
					newTeam: this.user.group_name !== 'supervisor' ? this.form.team.id : null,
					newManager: ['broker', 'manager'].includes(this.user.group_name) ? this.form.manager.value : null,
					newUser: this.newUserComputed
				}

				this.setLoader('modalLoad', true)
 
				user
					.destroy('', this.user.id, formData)
					.then(response => {
						if (response.data && response.data.status !== 'error') {
							setTimeout(() => {
								this.setLoader('modalLoadSuccess', false)
								setTimeout(() => {
									this.$root.$emit(this.eventSuccess)
									this.close()
								}, 1000)
							}, 500)
						}else { 
							this.$toastr.e(response.data.msg)
							this.setLoader('modalLoad', false)
						}
					})
					.catch(error => {
						this.setLoader('modalLoad', false)
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
			},

			loadManagers(id){
				this.managers = []
				this.setLoader('managerLoader', true)
				team
					.getManagersByTeam(id)
					.then(response => {
						if (response.data && response.data.status !== 'error') {
							this.managers = response.data.map(item => {
								return {
									label: item.first_name,
									value: item.manager_id,
									id: item.id
								}
							})

							if (this.user && this.user.group_name == 'manager')
								this.managers = this.managers.filter((manager) => manager.id != this.user.id)

							if (this.autoManager && this.managers.length > 0) {
								this.form.manager 
								= this.managers.length > 1 && this.user.manager_id
								? this.managers.find((manager) => manager.value == this.user.manager_id)
								: this.managers[0]
							}
						}else{
							if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					}).finally(() => {
						this.setLoader('managerLoader', false)
					})
			},

			loadSupervisors(id){
				this.supervisors = []
				this.setLoader('supervisorLoader', true)
				team
					.getSupervisorByTeam(id)
					.then(response => {
						if (response.data && response.data.status !== 'error') {
							this.supervisors = response.data.map(item => {
								return {
									label: item.first_name,
									id: item.id
								}
							})

							if (this.user && this.user.group_name == 'supervisor')
								this.supervisors = this.supervisors.filter((supervisor) => supervisor.id != this.user.id)
						}else{
							if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					}).finally(() => {
						this.setLoader('supervisorLoader', false)
					})
			},

			loadBrokers(value){
				if (this.user.group_name === 'broker' && value && value.value) {
					this.brokers = []
					this.setLoader('brokerLoader', true)
					team
						.getBrokersByManager(value.value)
						.then(response => {
							if (response.data && response.data.status !== 'error') {
								this.brokers = response.data.map(item => {
									return {
										label: item.first_name,
										id: item.id
									}
								})

								if (this.user && this.user.group_name == 'broker')
									this.brokers = this.brokers.filter((broker) => broker.id != this.user.id)
							}else{
								if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						}).finally(() => {
							this.setLoader('brokerLoader', false)
						})

				}else if(this.user.group_name === 'manager'){
					this.disableSubmitHandler()
				}
			},

			/**
			 * Carrega os usuarios dinamicamente baseado no grupo selecionado
			 */
			dinamycHandler(value){
				if (value) {
					if (this.user.group_name === 'supervisor') {
						this.loadSupervisors(value.id)
					}else {
						this.loadManagers(value.id)
					}
				}
			},

			/**
			 * Habilita ou não o botao baseado no valor
			 */
			disableSubmitHandler(){
				this.layout.isDisableSubmit = true

				switch (this.user.group_name) {
					case 'broker':
						if (this.form.broker && this.form.broker.id) this.layout.isDisableSubmit = false
						break;
					case 'manager':
						if (this.form.manager && this.form.manager.id) this.layout.isDisableSubmit = false
						break;
					case 'supervisor':
						if (this.form.supervisor && this.form.supervisor.id) this.layout.isDisableSubmit = false
						break;
				}
			},

			setLoader(loader, bool) {
				this.loader[loader] = bool
			},
		},

		watch: {
			"form.team"(newVal, oldVal) {
				if (newVal == oldVal)
					return
					
				if (Array.isArray(newVal)) {
					this.resetForm()

					this.teams       = []
					this.supervisors = []
					this.managers    = []
					this.brokers     = []

					return
				}

				this.dinamycHandler(newVal)
			},

			"form.supervisor": {
				handler() {
					this.disableSubmitHandler()
				},

				deep: true,
			},

			"form.manager"(newVal, oldVal) {
				if (newVal == oldVal)
					return

				if (Array.isArray(newVal)) {
					this.brokers     = []
					return
				}

				this.loadBrokers(newVal)
			},

			"form.broker": {
				handler() {
					this.disableSubmitHandler()
				},

				deep: true,
			},
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
